import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet,useNavigate } from "react-router-dom";
import { Switch } from "@headlessui/react";
import { Auth } from "aws-amplify";
import Button from "../layout/button";
import LoadingSpinner from "../layout/spinner";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

import { askToQRobotFromAPI } from "../../services/qRobotService";
import { addSurveyFromAPI } from "../../services/surveyService";
import { updateTabStates,updateTabPath } from "../../store/actions";
import { getSurveyDurationFromAPI } from "../../services/surveyLogs";
import { initializeSurveyCreateJob,getActiveSurveyProgress } from "../../services/surveyJobInitialize";

export default function QRobot() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const themeMode = useSelector((state) => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  let [token, setToken] = useState("");
  // const [numberOfQuestions, setNumberOfQuestions] = useState(10);
  // const [oneSection, setOneSection] = useState(false);
  const [surveyTitle, setSurveyTitle] = useState("");
  const [promptText, setPromptText] = useState("");
  const [surveyCreatingInfo, setSurveyCreatingInfo] = useState(false);
  const [surveyCreatingError, setSurveyCreatingError] = useState(false);
  const [pageIsLoading,setPageIsLoading]=useState(false)
  const [selectedFunction, setSelectedFunction] = useState("");
  const [qRobotSteps, setQRobotSteps] = useState([
    { id:1,tourId: "qrobotSurveyTitle", name: "Survey Title", href: "#", status: "current" },
    { id:2,tourId: "qrobotSurveyDetail", name: "Description", href: "#", status: "upcoming" },
    { id:3,tourId: "qrobotSurveyTopics", name: "Topics", href: "#", status: "upcoming" },
  ]);
  const[avgSeconds,setAvgSeconds] = useState()
  const [progress, setProgress] = useState(0);
  const [timer, setTimer] = useState(false)
  // const [showQuestionTypes, setShowQuestionTypes] = useState(false);

  // const handleQuestionTypeClick = (questionType) => {
  //     questionType.selected = !questionType.selected;
  //     setQuestionTypes([...questionTypes]);
  // }

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }
  useEffect(() => {
      if (token.length > 0) {
          if (selectedFunction === "handleAskAI") {
            handleAskAI();
          } else if (selectedFunction === "saveQRobotSurvey") {
            saveQRobotSurvey();
          }
          setSelectedFunction("");
      }
  }, [token]);

  const handleNextStep = () => {
    const currentStep = qRobotSteps.find((step) => step.status === "current");
    const currentIndex = qRobotSteps.findIndex(
      (step) => step.status === "current"
    );
    currentStep.status = "upcoming";
    qRobotSteps[currentIndex + 1].status = "current";
    setQRobotSteps([...qRobotSteps]);
  };

  const handlePreviousStep = () => {
    const currentStep = qRobotSteps.find((step) => step.status === "current");
    const currentIndex = qRobotSteps.findIndex(
      (step) => step.status === "current"
    );
    currentStep.status = "upcoming";
    qRobotSteps[currentIndex - 1].status = "current";
    setQRobotSteps([...qRobotSteps]);
  };

  const [topics, setTopics] = useState([]);
  const [topicName, setTopicName] = useState("");
  const [questionCount,setQuestionCount]= useState(0)
  const handleAddTopic = (e) => {
    if (e.key === "Enter" || e.type === "blur") {
      // if (topicName !== "" && ((oneSection && topics.length === 0) || !oneSection)) {
      if (topicName !== "" && !topics.includes(topicName)) {
        setTopics([...topics, topicName]);
        setTopicName("");
      }
    }
  };

  const updateTopic = (value, index) => {
    const updatedTopics = topics.map((topic, i) => {
      if (i === index) {
        return value;
      }
      return topic;
    });
    setTopics(updatedTopics);
  };

  const handleDeleteTopic = (index) => {
    const updatedTopics = topics.filter((topic, i) => i !== index);
    setTopics(updatedTopics);
  };

  const setQRobotStep = (stepName) => {
    const newSteps = qRobotSteps.map((step) => {
      if (step.name === stepName) {
        step.status = "current";
      } else {
        step.status = "upcoming";
      }
      return step;
    });
    setQRobotSteps(newSteps);
  };

  async function handleAskAI() {
    setPageIsLoading(true)
     
    const obj = {
      prompt: promptText,
    };

    await askToQRobotFromAPI(token, obj)
      .then((result) => {
        setTopics(result.resp);
        setPageIsLoading(false)
      })
      .catch((error) => {
        setPageIsLoading(false)
        if (error.message === "Request failed with status code 401") {
            setSelectedFunction("handleAskAI");
            checkAuth();
        }
      });

  }

  async function saveQRobotSurvey() {
    setTimer(true)
    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", true));
    const userCognitoInfo = await Auth.currentUserInfo();
    // console.log("questioncount",questionCount)
    const obj = {
      survey_name: surveyTitle,
      organization: userCognitoInfo.attributes["custom:org_name"],
      prompt: promptText,
      // question_number: numberOfQuestions,
      q_robot_headers: topics,
      // one_section: oneSection,
      question_types: ["radiogroup"],
      question_count : questionCount
    };
    await initializeSurveyCreateJob(token, obj)
      .then((result) => {
        // console.log(result)
        setSurveyCreatingInfo(true);
       
      })
      .catch((error) => {
        if (error?.message === "Request failed with status code 401") {
          setSelectedFunction("saveQRobotSurvey");
          checkAuth();
        } else {
          // console.log("error",error)
          setSurveyCreatingError(true);
          if (error.message === "Request failed with status code 400") {
          }
        }
      })
      .finally(() => {
        dispatch(
          updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false)
        );
      });
      const durationObj ={
        type : "q-robot",
        question_count : questionCount
      }
      await getSurveyDurationFromAPI(token,durationObj)
      .then((result)=>{
        // console.log("gelen result",result)
        let seconds = result["avg_duration_seconds"]
        startProgress(seconds)
        setAvgSeconds(seconds)
      })
      dispatch(updateTabStates(topMenuTabs.activeTab, 'homeSelectedTab', "Surveys"));
      dispatch(updateTabPath(topMenuTabs.activeTab, 'Home', `/home`));
        navigate("/home");
      //  const result = await getActiveSurveyProgress(token);
      //  console.log(result)
  }
  async function getSurveyProgress(){
      const result = await getActiveSurveyProgress(token);
       console.log(result)
  }
const startProgress = (avgSeconds) => {
  // console.log("startProgress")
  // console.log(avgSeconds)
  const startTime = Date.now();
  
  localStorage.setItem("survey_progress_start", startTime);
  localStorage.setItem("survey_progress_duration", avgSeconds);
};
const calculateProgress = () => {
  const start = localStorage.getItem("survey_progress_start");
  const duration = localStorage.getItem("survey_progress_duration");

  if (!start || !duration) return 0;

  const elapsed = (Date.now() - Number(start)) / 1000;
  const progress = Math.min((elapsed / Number(duration)) * 100, 100);

  return Math.floor(progress);
};
useEffect(() => {
  setProgress(calculateProgress());

  const interval = setInterval(() => {
    const p = calculateProgress();
    setProgress(p);

    if (p >= 100) {
      clearInterval(interval);
      localStorage.removeItem("survey_progress_start");
      localStorage.removeItem("survey_progress_duration");
    }
  }, 1000);

  return () => clearInterval(interval);
},[])
  return (
    <div className="flex flex-col justify-center items-center gap-4 p-4 px-auto sm:pl-12 mx-auto mt-4">
      <Outlet/>
    <div className="flex flex-col justify-center items-center gap-4 p-4 px-auto sm:pl-12 mx-auto mt-4">
      
      <nav
        aria-label="Progress"
        className={`max-w-[100vh] w-full rounded-md ${
          themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#1530720d]"
        }`}
      >
        <ol
          role="list"
          className="divide-y divide-[#ffffff0f] rounded-md border border-[#ffffff0f] md:flex md:divide-y-0"
        >
          {qRobotSteps.map((step, stepIdx) => (
            <li
              key={step.name}
              className="relative md:flex md:flex-1"
              id={step.tourId}
              onClick={() => setQRobotStep(step.name)}
            >
              {step.status === "current" ? (
                <a
                  href={step.href}
                  aria-current="step"
                  className="flex items-center px-6 py-4 text-xs sm:text-sm font-medium"
                >
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-[#4d7ff5]">
                    <span className="text-[#4d7ff5]">{step.id}</span>
                  </span>
                  <span className="ml-4 text-xs sm:text-sm font-medium text-[#4d7ff5]">
                    {step.name}
                  </span>
                </a>
              ) : (
                <a href={step.href} className="group flex items-center">
                  <span className="flex items-center px-6 py-4 text-xs sm:text-sm font-medium">
                    <span className="flex size-10 shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-[#4d7ff5]">
                      <span className="text-gray-500 group-hover:text-[#4d7ff5]">
                        {step.id}
                      </span>
                    </span>
                    <span className="ml-4 text-xs sm:text-sm font-medium text-gray-500 group-hover:text-[#4d7ff5]">
                      {step.name}
                    </span>
                  </span>
                </a>
              )}

              {stepIdx !== qRobotSteps.length - 1 ? (
                <>
                  <div
                    aria-hidden="true"
                    className="absolute right-0 top-0 hidden h-full w-5 md:block"
                  >
                    <svg
                      fill="none"
                      viewBox="0 0 22 80"
                      preserveAspectRatio="none"
                      className="size-full text-[#ffffff0f]"
                    >
                      <path
                        d="M0 -2L20 40L0 82"
                        stroke="currentcolor"
                        strokeWidth="3"
                        vectorEffect="non-scaling-stroke"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </>
              ) : null}
            </li>
          ))}
        </ol>
      </nav>
      {qRobotSteps.find((step) => step.status === "current").name ===
        "Survey Title" && (
        <div
          className={`flex flex-col items-center justify-start gap-4 p-4 max-w-[100vh] w-full rounded-md ${
            themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#1530720d]"
          }`}
        >
          <div className="flex flex-row w-full items-center">
            {/* <div className="text-white text-xs sm:text-sm w-1/2">Survey Title</div> */}
            <input
              className={`pl-2 pt-1 ${
                themeMode === "dark" ? "text-white" : "text-black"
              } text-xs sm:text-sm w-full border-0 bg-transparent focus-visible:outline-none`}
              value={surveyTitle}
              onChange={(e) => setSurveyTitle(e.target.value)}
              type="text"
              placeholder="New survey"
            />
          </div>
          {/* <div className="flex flex-row w-full items-center">
                        <div className="text-white text-[0.875rem] w-1/2">One Section</div>
                        <Switch
                            checked={oneSection}
                            onChange={() => setOneSection(!oneSection)}
                            className="group relative ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                        >
                            <span className="sr-only">Use setting</span>
                            <span
                                aria-hidden="true"
                                className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                            />
                        </Switch>
                    </div> */}
          {/* <div className="flex flex-row w-full items-center">
                        <div className="text-white text-[0.875rem] w-1/2">Question Types</div>
                        <div className="relative">
                            {questionTypes.filter(x => x.selected).length == 0 && (
                                <button className="text-white text-[0.875rem] p-2 border border-[#ffffff05] bg-[#2c3040] hover:bg-[#ffffff0a] rounded-md"
                                    onClick={() => setShowQuestionTypes(!showQuestionTypes)}
                                >
                                    Question Types
                                </button>
                            )}
                            {questionTypes.filter(x => x.selected).length == 1 && (
                                <button className="text-white text-[0.875rem] p-2 border border-[#ffffff05] bg-[#2c3040] hover:bg-[#ffffff0a] rounded-md"
                                    onClick={() => setShowQuestionTypes(!showQuestionTypes)}
                                >
                                    {questionTypes.filter(x => x.selected)[0].name}
                                </button>
                            )}
                            {questionTypes.filter(x => x.selected).length > 1 && (
                                <button className="text-white text-[0.875rem] p-2 border border-[#ffffff05] bg-[#2c3040] hover:bg-[#ffffff0a] rounded-md"
                                    onClick={() => setShowQuestionTypes(!showQuestionTypes)}
                                >
                                    {questionTypes.filter(x => x.selected).length} Question Types
                                </button>
                            )}
                            {showQuestionTypes && (
                                <div className="absolute flex flex-col top-12 left-0 min-w-[200px] border border-[#ffffff05] bg-[#2c3040] max-h-[100px] overflow-y-auto rounded-md z-[10000]">
                                    {questionTypes.map((questionType) => (
                                        <div key={questionType.value} className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                            onClick={() => handleQuestionTypeClick(questionType)}
                                        >
                                            <div className="flex items-center justify-start">
                                                <span>{questionType.img}</span>
                                                <span className="ml-1">{questionType.name}</span>
                                            </div>
                                            {questionType.selected && (
                                                <div>
                                                    <svg className="size-3 mt-1" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clipRule="evenodd" d="M14.8536 3.14645C15.0488 3.34171 15.0488 3.65829 14.8536 3.85355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645C2.34171 6.95118 2.65829 6.95118 2.85355 7.14645L6.5 10.7929L14.1464 3.14645C14.3417 2.95118 14.6583 2.95118 14.8536 3.14645Z"></path></svg>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div> */}
          {/* <div className="flex flex-row w-full items-center">
                        <div className="text-white text-[0.875rem] w-1/2">Number Of Question</div>
                        <input className="text-white text-[1.25rem] border-0 bg-transparent focus-visible:outline-none" type="number" value={numberOfQuestions}
                            onChange={(e) => setNumberOfQuestions(e.target.value)} />
                    </div> */}
          <div className="flex flex-row w-full items-center justify-end">
            <Button
              text="Next"
              onClick={() => handleNextStep()}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              }
              iconPosition={"right"}
              className=" py-1 px-2"
              type="button"
            />
          </div>
        </div>
      )}
      {qRobotSteps.find((step) => step.status === "current").name ===
        "Description" && (
        <div
          className={`flex flex-col items-center justify-start gap-4 p-4 max-w-[100vh] min-h-[22vh] w-full rounded-md ${
            themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#1530720d]"
          }`}
        >
          <div className="flex flex-row w-full items-center">
            <textarea
              id="comment"
              name="comment"
              rows={5}
              value={promptText}
              onChange={(e) => setPromptText(e.target.value)}
              placeholder="Please describe your survey..."
              className={`resize-y block w-full rounded-md resize-none bg-transparent px-3 py-1.5 ${
                themeMode === "dark" ? "text-white" : "text-black"
              } text-xs sm:text-sm placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#4d7ff5]`}
   
            />
          </div>
          <div className="flex flex-row w-full items-center justify-between">
            <Button
              text="Previous"
              onClick={() => handlePreviousStep()}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4 mr-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              }
              iconPosition={"left"}
              className=" py-1 px-2"
              type="button"
            />
            <Button
              text="Next"
              onClick={() => handleNextStep()}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4 ml-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              }
              iconPosition={"right"}
              className=" py-1 px-2"
              type="button"
            />
          </div>
        </div>
      )}
      {qRobotSteps.find((step) => step.status === "current").name ===
        "Topics" && (
        <div
          className={`flex flex-col items-center justify-start gap-0 p-4 max-w-[100vh] min-h-[22vh] max-h-[40vh] w-full rounded-md ${
            themeMode === "dark" ? "bg-[#a5bdff0d]" : "bg-[#1530720d]"
          }`}
        >
          <div className="flex flex-col w-full items-center min-h-[14.9vh] overflow-y-auto">
              <input  className={`w-full pl-1 ${
                  themeMode === "dark" ? "text-white" : "text-black"
                } text-xs sm:text-sm border-0 bg-transparent focus-visible:outline-none`}
                type="number"
                min={5}
                placeholder="Question Count"
                // placeholder="On which topics should the survey be created?"
                value={questionCount}
                onChange={(e) => setQuestionCount(e.target.value)}/>
                   <div
              className={`flex flex-row w-full items-center ${
                themeMode === "dark"
                  ? "hover:bg-[#2c3040]"
                  : "hover-bg-[fcfcfe]"
              } p-1 rounded-md`}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="16.000000pt"
                height="16.000000pt"
                viewBox="0 0 16.000000 16.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"
                  fill="#9CA3AF"
                  stroke="none"
                >
                  <path d="M131 115 c-2 -30 -20 -45 -54 -45 -22 0 -28 4 -23 15 4 12 2 13 -14 2 -25 -15 -25 -20 2 -43 19 -17 21 -17 15 -1 -5 14 -1 17 27 17 39 0 59 20 53 52 -4 20 -4 20 -6 3z" />
                </g>
              </svg>
              <input
                className={`w-full pl-1 ${
                  themeMode === "dark" ? "text-white" : "text-black"
                } text-xs sm:text-sm border-0 bg-transparent focus-visible:outline-none`}
                type="number"
                placeholder="Add a topic which it should the survey be created..."
                // placeholder="On which topics should the survey be created?"
                value={topicName}
                onChange={(e) => setTopicName(e.target.value)}
                onKeyDown={(e) => handleAddTopic(e)}
                onBlur={(e) => handleAddTopic(e)}
              />
            
            </div>
            {topics.map((topic, index) => (
              <div
                key={`${topic}-${index}`}
                className={`flex flex-row group w-full items-center ${
                  themeMode === "dark"
                    ? "hover:bg-[#2c3040]"
                    : "hover:bg-[#fbfbfc]"
                } p-1 rounded-md`}
              >
                <input
                  className={`w-full pl-1 ${
                    themeMode === "dark" ? "text-white" : "text-black"
                  } text-xs sm:text-sm border-0 bg-transparent focus-visible:outline-none`}
                  type="text"
                  value={topic}
                  onChange={(e) => updateTopic(e.target.value, index)}
                />
                <button
                  title="Delete Page"
                  className={`hidden group-hover:block flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${
                    themeMode === "dark" ? "text-[#FFFFFF]" : "text-black"
                  } cursor-pointer group inline-flex items-center  py-1 pl-2 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                  onClick={() => handleDeleteTopic(index)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          <div className="flex flex-row w-full items-center justify-between pt-3">
          <Button
              text="Previous"
              onClick={() => handlePreviousStep()}
              disabled={false}
              themeMode={themeMode}
              icon={
                <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-4 h-4 mr-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              }
              iconPosition={"left"}
              className=" py-1 px-2"
              type="button"
            />
            <div className="flex gap-2">
            <Button
              text="Ask to AI"
              onClick={() => handleAskAI()}
              disabled={questionCount==0}
              themeMode={themeMode}
              className=" py-1 px-2"
              type="button"
            />
              <Button
              text="Create My Survey"
              onClick={() => saveQRobotSurvey()}
              disabled={questionCount==0}
              themeMode={themeMode}
              className=" py-1 px-2"
              type="button"
            />
           
            </div>
          </div>
        </div>
      )}

      {/* {timer &&(
      <div>
      <div className="w-full bg-gray-200 rounded h-2">
          <div
            className="bg-blue-600 h-2 rounded transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}>
          %{progress} tamamlandı
        </p>
      </div>
      )} */}
      <Dialog
        open={surveyCreatingInfo}
        onClose={setSurveyCreatingInfo}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    The survey is being created, please follow the
                    notifications.
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setSurveyCreatingInfo(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={surveyCreatingError}
        onClose={setSurveyCreatingError}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    Unable to create survey, please check parameters.
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setSurveyCreatingError(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
       {pageIsLoading && (
                    <LoadingSpinner />
                  )}
                 
    </div>
    </div>
    
  );
}
